<template>
  <div>
    <template v-for="(item, i) in value.image">
      <div
        :key="i"
        class="message mr-2"
        style="
        position: relative;
        border-radius: 12px;
        width: 181px;
        overflow-wrap: break-word;
        min-height: 22px;
        min-width: 14px;
        line-height: 15.36px;
        overflow: hidden;
        "
      >
        <uploadfile
          ref="answer"
          v-model="value.image[i]"
          :height="181"
          data-vv-as="Image"
          :data-vv-name="'answer_' + '_image_'"
          v-validate
        ></uploadfile>
      </div>
    </template>
    <span class="mt-3">{{ $t('set_image_size') }}</span>
    <v-radio-group class="mt-0" color="primary" v-model="value.option" col>
      <v-radio color="primary" :value="'2to1'">
        <template slot="label">
          <span> 2:1</span>
        </template>
      </v-radio>
      <v-radio color="primary" :value="'1to1'">
        <template slot="label">
          <span> 1:1</span>
        </template>
      </v-radio>
    </v-radio-group>

    <span>{{ $t('set_image_distance_between_edges') }}</span>
    <v-checkbox
      class="mt-0"
      v-model="value.padding"
      color="primary"
      :label="$t('Distance between edges')"
    ></v-checkbox>

    <span>{{ $t('set_image_action') }}</span>
    <v-radio-group class="mt-0" color="primary" @change="setInput" v-model="action" col>
      <v-radio color="primary" :value="'link'">
        <template slot="label">
          <span>{{ $t('Link') }}</span>
        </template>
      </v-radio>
      <v-radio color="primary" :value="'phone'">
        <template slot="label">
          <span>{{ $t('phone_no') }}</span>
        </template>
      </v-radio>
    </v-radio-group>
    <div v-if="action === 'link'">
      <label for="points" class="caption">{{ $t('Link') }} ( {{ $t('only_use_https') }})</label>

      <div class="form-control" :class="{ 'has-error': errors.has('buttonLink') }">
        <textarea
          name="buttonLink"
          key="button-link"
          :data-vv-name="'buttonLink'"
          rows="10"
          class="form-control"
          style="width: 100%; resize: vertical; height: 50px;"
          v-model="link"
          :data-vv-as="$t('Link')"
          v-validate="'isUrl'"
          placeholder="https://www.website.com"
          @blur="setInput"
        ></textarea>
        <span class="text-error" v-show="errors.has('buttonLink')">{{
          errors.first('buttonLink')
        }}</span>
      </div>
    </div>
    <div v-else>
      <span>{{ $t('when_customer_clicks_this_picture') }}</span>
      <label for="points" class="caption">
        <div class="mt-1 mb-1">({{ $t('when_user_use_mobile') }})</div>
      </label>
      <div class="col s12 form-control" :class="{ 'has-error': errors.has('phone') }">
        <input
          v-model="phone"
          name="phone"
          type="text"
          :data-vv-as="$t('Tel')"
          v-validate="{
            regex: phoneRegex
          }"
          @blur="setInput"
        />
        <div class="caption grey--text">Ex. +66812345678 or 123 or 1678</div>
        <span class="text-error" v-if="errors.has('phone')">{{ errors.first('phone') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile'
export default {
  props: ['value'],
  data() {
    return {
      action: 'link',
      link: '',
      phone: ''
    }
  },
  components: {
    uploadfile
  },
  computed: {
    phoneRegex() {
      const vm = this
      if (vm.$store.state.pagePhoneNumberlaos.includes(vm.$store.state.selectedBot.pageid)) {
        return /^[+]{1}[1-9]{1}[0-9]{0,2}[1-9]{2}[0-9]{8,9}$|^[0-9]{3,4}$/
      } else {
        return /^[+]{1}[1-9]{1}[0-9]{0,2}[1-9]{1}[0-9]{7,8}$|^[0-9]{3,4}$/
      }
    }
  },
  mounted() {
    const vm = this
    if (vm.phoneRegex.test(vm.value.url)) {
      vm.action = 'phone'
      vm.phone = vm.value.url
    } else {
      vm.action = 'link'
      vm.link = vm.value.url
    }
  },
  methods: {
    setInput() {
      const vm = this
      if (vm.action === 'phone') {
        vm.value.url = vm.phone
      } else {
        vm.value.url = vm.link
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/salePage/templateType/Photo.vue